<template>
    <div class="transactions-wrapper">
        <div class="transactions-main-container">
            <div class="transcations-heading">
                <h3>{{ $t("adminMenu.transactions") }}</h3>
            </div>
            <!-- Loader -->
            <MainLoader class="section-wrap" v-if="loadingStatements" />
            <!-- Main content -->
            <div v-if="!loadingStatements" class="transactions-content">
                <!-- Search bar -->
                <div class="transactions-search flex items-center gap-2">
                    <input type="text" v-model="searchInput" placeholder="Search by appointment id or name"
                        class="text-field text-field-extra-small text-field-small" />
                    <button v-if="debouncedSearchQuery" class="primary-btn extra-small search-button"
                        @click="clearSearch">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
                <!-- Datepicker -->
                <div class="datepicker-wrapper">
                    <div class="datepicker-buttons">
                        <!-- Button to open Datepicker -->
                        <button class="primary-btn extra-small" @click="handleShowDatepicker">
                            {{ selectedDate ? dateFormatter(selectedDate) : 'Select Date' }}
                        </button>
                        <!-- Optional: clear date button -->
                        <button v-if="selectedDate" class="primary-btn extra-small" @click="handleResetDate">
                            Clear Date
                        </button>
                    </div>
                    <!-- Popup Datepicker -->
                    <div v-if="showDatepicker" class="datepicker-popup">
                        <!-- <Datepicker v-model="selectedDate" :disabled-dates="disabledDates"
                            @selected="handleSelectedDate" :inline="true" /> -->

                        <Datepicker v-model="selectedDate" :inline="true" :time-config="{ enableTimePicker: false }"
                            :disabled-dates="disabledDates" :formats="{ preview: 'yyyy-MM-dd' }" :auto-apply="true"
                            @update:model-value="handleSelectedDate" />

                    </div>
                </div>
                <!-- Accordion -->
                <div id="accordion" class="statements">
                    <div v-if="statementsLoaded && filteredStatements.length === 0"
                        class="no-transactions section-wrap">
                        {{ $t("payments.noTransactions") }}
                    </div>
                    <div v-if="statementsLoaded && filteredStatements.length > 0">
                        <div v-for="(statement, index) in filteredStatements" :key="`statement-year${index}`"
                            class="accordion-group statements-year highlighted-box section-wrap">
                            <div class="card-header" :id="`headingOne${index}`">
                                <div class="card-wrap">
                                    <button class="btn btn-link" data-bs-toggle="collapse"
                                        :data-bs-target="`#collapseOne${index}`" aria-expanded="true"
                                        :aria-controls="`collapseOne${index}`">
                                        {{ statement.year }} - {{ $t("payments.statements") }}
                                    </button>
                                    <a v-on:click="sendStatementsEmail(statement.year)" href="javascript:void(0)"
                                        class="stantements-email-action">
                                        {{ $t("payments.email") }}
                                    </a>
                                </div>
                            </div>
                            <!-- Year accordion -->
                            <div :id="`collapseOne${index}`" class="collapse" :class="{
                                show:
                                    expandedAccordions.includes(`collapseOne${index}`) ||
                                    (!debouncedSearchQuery && index == 0),
                            }" :aria-labelledby="`headingOne${index}`" data-bs-parent="#accordion">
                                <div class="card-body">
                                    <div :id="`accordion-2${index}`" class="statements-months section-wrap">
                                        <div v-for="(month, i) in statement.items" :key="`statement-month${i}`"
                                            class="card statements-month">
                                            <div class="card-header" :id="`heading-One${i}`">
                                                <div class="card-wrap">
                                                    <button class="btn btn-link" data-bs-toggle="collapse"
                                                        :data-bs-parent="`#accordion-2${index}`"
                                                        :data-bs-target="`#collapse-One${i}`" aria-expanded="true"
                                                        :aria-controls="`collapse-One${i}`">
                                                        {{ month.month }} -
                                                        {{ $t("payments.statement") }}
                                                    </button>
                                                    <a v-on:click="sendStatementsEmail(statement.year, month.month)"
                                                        href="javascript:void(0)" class="stantements-email-action">
                                                        Email
                                                    </a>
                                                </div>
                                            </div>
                                            <!-- Month accordion -->
                                            <div :id="`collapse-One${i}`" class="collapse" :class="{
                                                show: expandedAccordions.includes(`collapse-One${i}`),
                                            }" :aria-labelledby="`heading-One${i}`"
                                                :data-bs-parent="`#accordion-2${index}`">
                                                <div class="card-body">
                                                    <div class="transactions">
                                                        <div v-if="month.orders.length > 0" class="transactions-list">
                                                            <div v-for="(trans, k) in month.orders.slice(0, month.displayLimit)"
                                                                :key="`transaction${index}-${k}`"
                                                                class="transaction-item highlighted-box">
                                                                <div class="left-col">
                                                                    <div class="trans-name">{{ trans.name }}</div>
                                                                    <div class="trans-date">{{ trans.date }}</div>
                                                                    <div class="trans-date">
                                                                        {{ trans.payment_type_text }}
                                                                    </div>



                                                                    <div>
                                                                        <div v-if="trans.appointment_id != 0"
                                                                            class="trans-signature transaction-button"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#openAppointmentModal"
                                                                            @click="openSignatureModal(trans)">
                                                                            {{ $t("payments.appointmentId") }}
                                                                            {{ trans.appointment_id }}
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <div class="right-col">
                                                                    <div class="trans-amount"
                                                                        :class="{ refunded: trans.status == 'refunded' }">
                                                                        {{ trans.amount }}
                                                                    </div>
                                                                    <div class="trans-payment-type">
                                                                        {{
                                                                            trans.status == "refunded"
                                                                                ? trans.status
                                                                                : trans.payment_type
                                                                        }}
                                                                    </div>
                                                                    <div>
                                                                        <div v-if="
                                                                            !isDemoClient(trans.client_id) &&
                                                                            trans.signature != '' &&
                                                                            trans.status != 'refunded'
                                                                        " class="trans-signature transaction-button"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#retriveSignature"
                                                                            @click="openSignatureModal(trans)">
                                                                            Retrieve signature
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="transaction-load-more">
                                                                <div class="primary-btn extra-small mobile"
                                                                    v-if="month.orders.length > month.displayLimit"
                                                                    @click="
                                                                        month.displayLimit += 10;
                                                                    $forceUpdate();
                                                                    ">
                                                                    {{ $t("payments.loadMore") }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Retrieve signature modal -->
        <div class="modal fade" id="retriveSignature" tabindex="-1" aria-labelledby="retriveSignatureLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content signature-modal">

                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ currentTransaction.name }}'s Signature
                        </h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body">

                        <MainLoader v-if="loadingSignatures" />

                        <template v-else>

                            <div v-if="currentTransaction.signature" class="signature-preview">
                                <img :src="viewSignature(currentTransaction.signature)" alt="Signature" />
                            </div>

                            <div v-else class="signature-empty">
                                <i class="fas fa-signature"></i>
                                <p>No signature found</p>
                            </div>

                            <div v-if="currentTransaction.signature" class="signature-actions">
                                <a :href="viewSignature(currentTransaction.signature) + '&download=1'" download
                                    class="btn btn-primary">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                    Download Signature
                                </a>
                            </div>

                        </template>

                    </div>

                </div>
            </div>
        </div>

        <!-- Open appointment modal -->
        <div class="modal fade" id="openAppointmentModal" tabindex="-1" aria-labelledby="openAppointmentModalLabel"
            aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content transaction-modal">

                    <div class="modal-header border-0">
                        <h5 class="modal-title fw-bold" id="openAppointmentModalLabel">
                            <i class="fas fa-calendar-check me-2 text-primary"></i>
                            Transaction Details
                        </h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>

                    <div class="modal-body">

                        <div class="info-card">
                            <h6 class="section-title">Appointment</h6>

                            <div class="info-row">
                                <span>ID</span>
                                <strong>#{{ currentTransaction.appointment_id }}</strong>
                            </div>

                            <div class="info-row">
                                <span>Date</span>
                                <strong>{{ currentTransaction.date }}</strong>
                            </div>

                            <div class="info-row">
                                <span>Name</span>
                                <strong>{{ currentTransaction.name }}</strong>
                            </div>
                            <div class="info-row">
                                <span>Name</span>
                                <strong>{{ currentTransaction.created_at }}</strong>
                            </div>
                        </div>

                        <div class="info-card mt-3">
                            <h6 class="section-title">Payment</h6>

                            <div class="info-row">
                                <span>Amount</span>
                                <strong class="text-success">
                                    {{ currentTransaction.amount }}
                                </strong>
                            </div>
                        </div>

                        <button v-if="currentTransaction.appointment_id != 0"
                            @click="openAppointmentDetails(currentTransaction.appointment_id)"
                            class="btn-primary w-100 mt-4">

                            View Appointment #{{ currentTransaction.appointment_id }}

                        </button>

                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import api from "../../services/apiEndpoints.js";
import auth from "./../../services/auth.js";
import messages from "./../../services/messages.js";
import hash from "hash.js";
import MainLoader from "./general-components/MainLoader.vue";
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from "moment";
import { Modal } from "bootstrap";


export default {
    data() {
        return {
            user: null,
            statements: [],
            statementsLoaded: false,
            loadingStatements: false,
            searchInput: "",
            debouncedSearchQuery: "",
            expandedAccordions: [],
            debounceTimer: null,
            currentTransaction: {},
            loadingSignatures: false,
            selectedDate: null,
            showDatepicker: false,
        };
    },
    watch: {
        searchInput(newVal) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.debouncedSearchQuery = newVal.trim();
            }, 500);
        },
        debouncedSearchQuery(newVal) {
            if (newVal) {
                // Use a silent flag or check to prevent recursive clearing
                this.selectedDate = null;
                this.showDatepicker = false;
            }
            this.calculateExpansions();
        },
        selectedDate(newVal) {
            if (newVal) {
                // Clear search text without triggering a loop
                this.searchInput = "";
                this.debouncedSearchQuery = "";
            }
            this.calculateExpansions();
        }
    },
    computed: {
        // Pure function: ONLY filters data
        filteredStatements() {
            const query = this.debouncedSearchQuery.toLowerCase();
            const selectedDateStr = this.selectedDate
                ? moment(this.selectedDate).format("YYYY-MM-DD")
                : null;

            return this.statements
                .map((statement) => {
                    const filteredItems = statement.items
                        .map((month) => {
                            const filteredOrders = month.orders.filter((trans) => {
                                const matchesSearch = !query ||
                                    trans.name.toLowerCase().includes(query) ||
                                    trans.payment_type_text.toLowerCase().includes(query) ||
                                    trans.status.toLowerCase().includes(query) ||
                                    (trans.appointment_id && trans.appointment_id.toString().includes(query));

                                const matchesDate = !selectedDateStr ||
                                    moment(trans.date, "MMM DD YYYY / hh:mm A").format("YYYY-MM-DD") === selectedDateStr;

                                return matchesSearch && matchesDate;
                            });
                            return { ...month, orders: filteredOrders };
                        })
                        .filter((month) => month.orders.length > 0);

                    return { ...statement, items: filteredItems };
                })
                .filter((statement) => statement.items.length > 0);
        },
        availableDates() {
            const dates = new Set();
            this.statements.forEach(s => s.items.forEach(m => m.orders.forEach(t => {
                dates.add(moment(t.date, "MMM DD YYYY / hh:mm A").format("YYYY-MM-DD"));
            })));
            return dates;
        },
    },
    mounted() {
        this.user = auth.state.user;
        this.getStatementsList();
    },
    methods: {
        clearSearch() {
            this.searchInput = "";
            this.debouncedSearchQuery = "";
        },
        getStatementsList() {
            this.loadingStatements = true;
            this.$http
                .get(api.actions.get_statements)
                .then((response) => {
                    this.statementsLoaded = true;
                    if (
                        response &&
                        response.data &&
                        response.data.statements &&
                        response.data.statements.length
                    ) {
                        this.statements = response.data.statements;
                        this.statements.forEach((item) => {
                            item.items.forEach((month) => (month.displayLimit = 10));
                        });
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loadingStatements = false;
                });
        },
        sendStatementsEmail(year, month) {
            const monthMap = {
                Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
                Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12,
            };
            const data = { year };
            if (month) data.month = monthMap[month];
            this.$http
                .post(api.actions.send_statements_to_email, data)
                .then((response) => {
                    if (!response.data?.error) {
                        messages.successMessage(
                            messages.GLOBAL_MESSAGES.STATEMENTS_EMAIL_SENT + this.user.email
                        );

                    } else {
                        messages.errorMessage(response.data.message);
                    }

                })
                .catch((err) => {
                    console.error('sendStatementsEmail failed:', err);
                });
        },
        viewSignature(signature) {
            const token = hash.sha1().update(signature).digest("hex");
            return api.actions.view_signature + "?file_name=" + signature + "&token=" + token;
        },
        isDemoClient(user_id) {
            return import.meta.env.VITE_DEMO_CLIENT_ID == user_id;
        },
        openSignatureModal(transaction) {
            this.currentTransaction = transaction;
            this.loadingSignatures = false;
        },
        openAppointmentDetails(id) {
            const eventModalEl = document.getElementById("openAppointmentModal");
            const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
            eventModalInstance.hide();

            sessionStorage.setItem("openEventId", id);
            window.scrollTo(0, 0);
            this.$router.push("/app");
        },
        handleSelectedDate(date) {
            this.selectedDate = date;
            this.showDatepicker = false;
        },
        handleShowDatepicker() {
            this.showDatepicker = !this.showDatepicker
        },
        handleResetDate() {
            this.selectedDate = null;
            this.showDatepicker = false;
        },
        dateFormatter(date) {
            return moment(date).format('MM/DD/YYYY');
        },
        // This replaces the logic that was inside the computed property
        calculateExpansions() {
            const expanded = [];
            const query = this.debouncedSearchQuery.toLowerCase();
            const dateStr = this.selectedDate ? moment(this.selectedDate).format("YYYY-MM-DD") : null;

            if (!query && !dateStr) {
                this.expandedAccordions = [];
                return;
            }

            this.statements.forEach((statement, index) => {
                statement.items.forEach((month, i) => {
                    const hasMatch = month.orders.some(trans => {
                        const mSearch = !query || trans.name.toLowerCase().includes(query) || (trans.appointment_id && trans.appointment_id.toString().includes(query));
                        const mDate = !dateStr ||
                            moment(trans.date, "MMM DD YYYY / hh:mm A").format("YYYY-MM-DD") === dateStr;
                        return mSearch && mDate;
                    });

                    if (hasMatch) {
                        expanded.push(`collapseOne${index}`);
                        expanded.push(`collapse-One${i}`);
                    }
                });
            });
            this.expandedAccordions = expanded;
        },
        disabledDates(date) {
            // Updated for @vuepic/vue-datepicker standard
            return !this.availableDates.has(moment(date).format("YYYY-MM-DD"));
        },
    },
    components: {
        MainLoader,
        Datepicker,
    },
};
</script>